import styled from 'styled-components';
import { getStepResultText, getDimensionResultText } from '../api/resultTexts';
import { getTotalObj } from '../api/common';
import './../style.css'
import './../css/bootstrap.css'
import './../css/dark.css'
import './../css/font-icons.css'
import './../css/components/ion.rangeslider.css'
import './../css/custom.css'
import './../css/fonts.css'

const Styles = styled.div`
border: solid 1px;
diplay: flex;
flex-direction: column;
width: fit-content; 
align-items: center;  

.title{
    font-weight: bold;

}
img {
    width:100px;
}
article{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.score{
    diplay: flex;
    flex-direction: row;
    align-items: center; 
    font-weight: bold;
}
.text{
    padding: 10px;
    align-text: left;
}
.text>*{
    diplay: flex;
    flex-direction: column;
    margin: 5px 0;
}
`

function renderStep(title, percentage) {
    const textObj = getStepResultText(title, percentage);
    return (
        <div className="text">
            <h5 className="title">Nível</h5>
            <span>{textObj.level}</span>
            <h5 className="title">Resultado</h5>
            <span>{textObj.result}</span>
            <h5 className="title">Recomendações</h5>
            {textObj.advice.map((a, i) => <span key={i}>{a}</span>)}
        </div>
    );
}

function renderDimension(title, percentage) {
    const textObj = getDimensionResultText(title, percentage);
    return (
        <div className="text">
            <h5 className="title">Nível</h5>
            <span>{textObj.level}</span>
            <h5 className="title">Resultado</h5>
            <span>{textObj.result}</span>
            <h5 className="title">Recomendações</h5>
            <span>{textObj.advice}</span>
        </div>
    );
}

const ResultCard = props => {
    const { stepTitle, dimensionTitle, allQuestions, answers, image } = props;
    const totals = getTotalObj(stepTitle, dimensionTitle, allQuestions, answers);
    return (
        <Styles>
            <span className="title">{totals.title}</span>
            <img alt="" src={image} />
            <article>
                <div className="score">{totals.total} / {totals.outOf} ({totals.percentage}%)</div>
            </article>

            {stepTitle && renderStep(stepTitle, totals.percentage)}
            {dimensionTitle && renderDimension(dimensionTitle, totals.percentage)}
        </Styles>
    )
}
export default ResultCard;